export type InitialView = 'all' | 'lucky-numbers'

export function parseDrawQuery(value: unknown): number | null {
  const raw = Array.isArray(value) ? value[0] : value
  if (raw == null || raw === '') return null
  const parsed = Number(raw)
  if (!Number.isFinite(parsed) || parsed <= 0) return null
  return Math.floor(parsed)
}

export function parseViewQuery(value: unknown): InitialView | null {
  const raw = Array.isArray(value) ? value[0] : value
  if (typeof raw !== 'string') return null
  const normalized = raw.trim().toLowerCase()
  if (normalized === 'all' || normalized === 'lucky-numbers') {
    return normalized
  }
  return null
}

function selectDrawIndex(
  draws: Array<{ event_id: number | string }>,
  drawId: number | null
): number {
  if (draws.length === 0) return -1
  if (drawId == null) return 0
  const index = draws.findIndex((draw) => Number(draw.event_id) === drawId)
  return index >= 0 ? index : 0
}

export function buildSelectedDrawsArray(
  draws: Array<{ event_id: number | string }>,
  drawId: number | null
): boolean[] {
  const selection = new Array(draws.length).fill(false)
  const index = selectDrawIndex(draws, drawId)
  if (index >= 0) {
    selection[index] = true
  }
  return selection
}
